

export default [
        /***
   * 
   * Companies
   * 
   */
  {
    path: '/companies',
    name: 'Companies',
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/companies.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/:id',
    name: 'Company',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/company.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/new',
    name: 'NewCompany',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/new_company.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/:id/edit',
    name: 'EditCompany',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/edit_company.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/:id/users',
    name: 'CompanyUsers',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/company_users.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/:id/add_user',
    name: 'Addusertocompany',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/add_user_to_company.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/:id/user/:user_id',
    name: 'Editusertocompany',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/edit_user_to_company.vue'),
    meta: { 
      requiresAuth: true
    }
  },
]